import React, {useEffect, useState} from "react";
import CreateEmployee from "./CreateEmployee";
import { FaChevronDown, FaChevronUp} from 'react-icons/fa';
import ViewEmployee from "./ViewEmployee";
import { Card, Row, Col, Table } from "react-bootstrap";
import CompanyAPIs from "../../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import { MdAddCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function ViewEmployees({CompanyID}){

    const navigate = useNavigate();
    const ColumnHeaders = ['First Name', 'Last Name', 'Phone', 'Email', '', ''];
    const [employeeData, setEmployeeData] = useState([]);
    const [showEmployees, setShowEmployees] = useState(false);
    const [showAdd, setShowAdd] = useState(false);

    const getCompanyEmployees = (id) => {
   
        CompanyAPIs.GetCompanyEmployees(id)
        .then((response) => {
            setEmployeeData(response.data);
        }) 
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }
    
    const handleAddNew = () => {
        setShowAdd(false);
        getCompanyEmployees(CompanyID);
    }

    const thData = () => {
        return ColumnHeaders.map((header, index) => {
            return(<th key={index}>{header}</th>)
        })
    }
    useEffect(() => {
        getCompanyEmployees(CompanyID);
    }, [CompanyID])

    return(
        <div className="project-section">
            {/* <div className="project-section-header">
                <h4 className="section-title">Employees ({employeeData.length})</h4>
            </div> */}

            <CreateEmployee companyID={CompanyID} handleAddNew={handleAddNew}/>

            
            <div className="mt-2">
                {employeeData.map((employee) => 
                    <ViewEmployee key={employee.id} companyID={CompanyID} getEmployees={getCompanyEmployees} employeeID={employee.id} /> 
                )}
            </div>
            
            
            {/* <div className={showEmployees ? 'employee-details active' : 'employee-details'}>           
            <hr/>
            <Card>
                <Card.Header>
                    <Row>
                        <Col>Employees</Col>  
                        <Col align='end'>
                            <span onClick={() => setShowAdd(!showAdd)}><MdAddCircle/></span>
                        </Col>  
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Table hover striped responsive>
                        <thead>
                            <tr>
                                {thData()}
                            </tr>
                        </thead>
                        <tbody>
                            {showAdd && <CreateEmployee companyID={CompanyID} handleAddNew={handleAddNew}/>}
                            {employeeData.map((employee) => {
                                
                                return (
                                    <ViewEmployee key={employee.id} companyID={CompanyID} getEmployees={getCompanyEmployees} employeeID={employee.id} />      
                                )
                            })}
                        </tbody>
                    </Table>
                </Card.Body>

            </Card> */}
            
               

            
        </div>
    )

}